import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Layout, Section, Eyebrow, FinalCTA } from "@/components/site/Layout";
import { practiceAreas } from "@/data/practice-areas";
import { CaseStudy, practiceCaseStudy } from "@/components/site/CaseStudy";
import { FAQSection } from "@/components/site/FAQSection";

export const Route = createFileRoute("/practice-areas")({
  component: () => <Outlet />,
});

export function PracticeAreasIndex() {
  return (
    <Layout>
      <section className="bg-hero-gradient text-primary-foreground">
        <div className="mx-auto max-w-7xl px-6 py-20">
          <Eyebrow><span className="text-[var(--gold)]">Practice Areas</span></Eyebrow>
          <h1 className="mt-6 font-display text-5xl md:text-6xl font-semibold max-w-3xl">SEO playbooks built for your specific practice.</h1>
          <p className="mt-6 max-w-2xl text-lg text-primary-foreground/80">Every practice area has different keywords, different intent, different competitors. Choose yours.</p>
        </div>
      </section>
      <Section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {practiceAreas.map((p) => (
            <Link key={p.slug} to="/practice-areas/$slug" params={{ slug: p.slug }} className="group rounded-xl border border-border bg-card p-7 hover:border-[var(--gold)] hover:shadow-[var(--shadow-card)] transition">
              <h2 className="text-2xl font-semibold">{p.shortName}</h2>
              <p className="mt-3 text-sm text-muted-foreground">{p.headline}</p>
              <div className="mt-5 text-sm font-semibold text-primary group-hover:text-[var(--gold-deep)]">View strategy →</div>
            </Link>
          ))}
        </div>
      </Section>
      <CaseStudy {...practiceCaseStudy(practiceAreas[0].slug, practiceAreas[0].name, practiceAreas[0].shortName, practiceAreas[0].results)} />
      <FAQSection
        tone="muted"
        title="Practice-area SEO, questions firms ask."
        items={[
          { q: "Do you specialize in one practice area or all of them?", a: "We build dedicated playbooks per practice, personal injury SEO looks nothing like estate planning SEO. Each program is led by a strategist with vertical experience." },
          { q: "Can you take my practice if you already work with a competitor?", a: "No. We enforce single-firm-per-practice-per-market exclusivity so our clients never compete against each other." },
          { q: "Which practice area has the fastest ROI?", a: "Higher-value verticals like personal injury and mass tort compound fastest in absolute revenue. DUI and family often show the fastest lead-volume lift." },
          { q: "Do you write the legal content?", a: "Yes, our editors write, and your attorneys approve. Every published page has attorney sign-off before it goes live." },
          { q: "Can you help launch a new practice area?", a: "Yes. We regularly help firms enter new verticals with topical hubs, city pages, and authority-building content built from day one." },
        ]}
      />
      <FinalCTA />
    </Layout>
  );
}